import { BOOKING_URL, CONTACT_EMAIL, EMAIL_COMPOSE_URL, FORA_URL } from "../data/site";
import { Countdown } from "./Countdown";
import { useCurrentFair } from "../lib/fairSchedule";

export const Header = () => {
  const { fair } = useCurrentFair();
  return (
  <header className="h-20 md:h-24 shrink-0 flex items-center px-5 md:px-10 justify-between gap-4 bg-paper z-50 relative">
    <a
      href="/"
      className="flex items-center gap-3 md:gap-6"
      aria-label="Enchanté home"
      data-testid="header-home-link"
    >
      <div className="translate-y-1 md:translate-y-1.5">
        <p className="serif text-2xl md:text-[26px] leading-none text-deep lowercase tracking-tight">
          enchanté
        </p>
        <p className="text-[9px] md:text-[10px] uppercase tracking-[0.2em] md:tracking-[0.3em] font-bold mt-0.5 text-deep leading-[1.4]">
          <span className="block md:inline">Art Fair</span>
          <span className="block md:inline md:before:content-['_']">Travel Advisory</span>
        </p>
      </div>
    </a>

    <div className="hidden lg:flex gap-12 xl:gap-16">
      <div className="flex flex-col">
        <span className="text-[10px] uppercase font-medium tracking-widest text-ink opacity-70">
          Powered by
        </span>
        <a
          href={FORA_URL}
          target="_blank"
          rel="noopener"
          className="text-sm font-medium text-ink border-b border-ink/30 hover:border-ink transition-colors"
          data-testid="header-fora-link"
        >
          Fora Travel
        </a>
      </div>
      <div className="flex flex-col">
        <span className="text-[10px] uppercase font-medium tracking-widest text-ink">
          <span className="opacity-70">Now booking</span>
          <Countdown />
        </span>
        <a
          href={BOOKING_URL}
          target="_blank"
          rel="noopener"
          className="text-sm font-medium text-ink border-b border-ink/30 hover:border-ink transition-colors"
          data-testid="header-now-booking-link"
        >
          {fair ? `${fair.name} · ${fair.short}` : "Enquiries open"}
        </a>
      </div>
      <div className="flex flex-col">
        <span className="text-[10px] uppercase font-medium tracking-widest text-ink opacity-70">
          Contact
        </span>
        <a href={EMAIL_COMPOSE_URL} target="_blank" rel="noopener" className="text-sm font-medium text-ink" data-testid="header-email-link">
          {CONTACT_EMAIL}
        </a>
      </div>
    </div>

    <a
      href={BOOKING_URL}
      target="_blank"
      rel="noopener"
      data-testid="header-plan-trip-cta"
      className="shrink-0 whitespace-nowrap px-3 md:px-6 py-2.5 bg-deep text-greige text-[10px] md:text-[11px] font-medium uppercase tracking-widest hover:opacity-80 transition-opacity"
    >
      Plan your trip
    </a>
  </header>
);
};
